export default function initMegaMenu() {
    // ==========================================================
    // MEGA MENU
    // ==========================================================

    const megaMenus = document.querySelectorAll(".mega-menu");

    megaMenus.forEach((megaMenu) => {
        const mainSubMenu = megaMenu.querySelector(":scope > .sub-menu");

        if (!mainSubMenu) {
            return;
        }

        const domains = Array.from(mainSubMenu.querySelectorAll(":scope > .menu-item"));

        if (!domains.length) {
            return;
        }

        // ==================================================
        // CRÉATION DE LA ZONE IMAGE
        // ==================================================

        const visual = document.createElement("div");

        visual.classList.add("mega-menu__visual");

        const image = document.createElement("img");

        image.alt = "";
        image.loading = "lazy";

        visual.appendChild(image);
        mainSubMenu.prepend(visual);

        // ==================================================
        // CHANGEMENT DE DOMAINE
        // ==================================================

        const activateDomain = (domain) => {
            domains.forEach((item) => {
                item.classList.remove("is-active");
            });

            domain.classList.add("is-active");

            const imageData = domain.querySelector(":scope > .mega-menu__domain-image-data");

            if (!imageData) {
                return;
            }

            const imageUrl = imageData.dataset.image;

            if (!imageUrl) {
                return;
            }

            image.src = imageUrl;
        };

        // ==================================================
        // DOMAINE PAR DÉFAUT
        // ==================================================

        activateDomain(domains[0]);

        // ==================================================
        // CLIC DOMAINE
        // ==================================================

        domains.forEach((domain) => {
            const domainLink = domain.querySelector(":scope > a");

            if (!domainLink) {
                return;
            }

            domainLink.addEventListener("click", (event) => {
                event.preventDefault();

                activateDomain(domain);
            });
        });
    });
}
